import { useBinanceSymbols } from "@/hooks/useBinanceSymbols";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import { useState } from "react";
import { Check } from "lucide-react";

interface SymbolSelectProps {
  value?: string;
  onValueChange: (value: string) => void;
  className?: string;
}

export function SymbolSelect({
  value,
  onValueChange,
  className,
}: SymbolSelectProps) {
  const { data: symbols } = useBinanceSymbols();
  const [search, setSearch] = useState("");

  return (
    <Command className={`rounded-lg border w-[200px] ${className}`}>
      <CommandInput
        placeholder="Search symbol..."
        value={search}
        onValueChange={setSearch}
        className="h-7 text-xs"
      />
      <CommandList>
        <CommandEmpty className="text-xs p-2">No symbols found.</CommandEmpty>
        <CommandGroup className="max-h-[200px] overflow-y-auto">
          {symbols
            ?.filter((s) => s.status === "TRADING")
            .filter((s) =>
              s.symbol.toLowerCase().includes(search.toLowerCase()),
            )
            .map((symbol) => (
              <CommandItem
                key={symbol.symbol}
                value={symbol.symbol}
                onSelect={(currentValue) => {
                  onValueChange(currentValue);
                  setSearch("");
                }}
                className="text-xs cursor-pointer"
              >
                <Check
                  className={`mr-2 h-3 w-3 ${
                    value === symbol.symbol ? "opacity-100" : "opacity-0"
                  }`}
                />
                {symbol.symbol}
                <span className="ml-2 text-xs text-muted-foreground">
                  {symbol.baseAsset}/{symbol.quoteAsset}
                </span>
              </CommandItem>
            ))}
        </CommandGroup>
      </CommandList>
    </Command>
  );
}
